import { createFileRoute, Outlet } from "@tanstack/react-router";
import { AccountError, AccountPending } from "@/features/account/navigation";

export const Route = createFileRoute("/_site/account")({
  head: () => ({
    meta: [
      { title: "Account | Softmax" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  pendingComponent: AccountPending,
  errorComponent: AccountError,
  component: AccountLayout,
});

function AccountLayout() {
  return (
    <main
      id="main"
      data-shell-page
      tabIndex={-1}
      className="focus:outline-none"
    >
      <Outlet />
    </main>
  );
}
